import { useEffect, useRef } from 'react';

const useBoardCursor = function(boardRef) {
  const cursorRef = useRef(null);

  useEffect(() => {
    const trackCursor = function(event) {
      cursorRef.current = {
        x: event.clientX,
        y: event.clientY
      };
    };

    document.addEventListener('pointermove', trackCursor);
    document.addEventListener('pointerdown', trackCursor);

    return () => {
      document.removeEventListener('pointermove', trackCursor);
      document.removeEventListener('pointerdown', trackCursor);
    };
  }, []);

  return function boardPosition() {
    const board = boardRef.current;
    const cursor = cursorRef.current;

    if (!board || !cursor) return undefined;

    const bounds = board.getBoundingClientRect();

    if (cursor.x < bounds.left || cursor.x > bounds.right || cursor.y < bounds.top || cursor.y > bounds.bottom) return undefined;

    const zoom = Number(board.dataset.zoom) || 1;

    // Reverse panning and zoom to locate the cursor on the canvas.
    return {
      x: (cursor.x - bounds.left - (Number(board.dataset.panX) || 0)) / zoom,
      y: (cursor.y - bounds.top - (Number(board.dataset.panY) || 0)) / zoom
    };
  };
};

export default useBoardCursor;
